import React from 'react';
import { ArticleCard } from '../ArticleCard';
import { SeeMoreButton } from '../SeeMoreButton';
import omit from 'lodash/omit';

import { HERO_STYLE } from '@eb/eds-media-card-content';

import { GA_VIEW_MORE_ACTION } from '../../SearchApp/constants';

const IMAGE_STYLE_FLUID = 'fluid';

const _getRemainingArticleCards = (
    cards,
    trackGAEventOnPageUnload,
    showSummary,
    classes = '',
) =>
    cards.map(({ id, name, ...cardProps }) => {
        let component = null;

        const props = showSummary ? cardProps : omit(cardProps, 'summary');

        if (name) {
            component = (
                <div className={classes} key={id}>
                    <ArticleCard
                        id={id}
                        name={name}
                        trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                        {...props}
                    />
                </div>
            );
        }

        return component;
    });

export const ArticleCardGroup = ({
    cards: [bigCard, cardOne, cardTwo, ...cards],
    linkUrl,
    onTrackClick,
    trackGAEventOnPageUnload,
    title,
}) => (
    <div className="eds-g-group">
        <div className="eds-show-up-mn article-bucket-container">
            <div className="eds-g-cell eds-g-cell-1-1 eds-g-cell-mw-6-12 eds-l-pad-right-2">
                <ArticleCard
                    style={HERO_STYLE}
                    imageStyle={IMAGE_STYLE_FLUID}
                    {...bigCard}
                    trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                />
            </div>
            <div className="eds-g-cell eds-g-cell-1-1 eds-g-cell-mw-6-12">
                {_getRemainingArticleCards(
                    [cardOne, cardTwo, ...cards],
                    trackGAEventOnPageUnload,
                    false,
                    'eds-g-cell eds-g-cell-sw-6-12',
                )}
            </div>
        </div>
        <div className="eds-show-down-sw">
            <div className="eds-g-cell eds-g-cell-1-1">
                {_getRemainingArticleCards(
                    [bigCard, cardOne, cardTwo],
                    trackGAEventOnPageUnload,
                    true,
                )}
            </div>
            <div className="eds-l-pad-top-6">
                <div className="eds-show-down-sn eds-align--center">
                    <div className="eds-g-cell">
                        <SeeMoreButton
                            linkUrl={linkUrl}
                            trackClick={onTrackClick}
                            title={title}
                            gaAction={GA_VIEW_MORE_ACTION}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export const FeaturedArticleCardGroup = ({
    cards,
    trackGAEventOnPageUnload,
}) => {
    //Assumes that API response will have 3 card responses
    const [primaryCard, ...remainingCards] = cards;

    return (
        <div className="eds-g-group">
            <div className="eds-show-up-mn featured-article-bucket-container">
                <div className="eds-g-cell eds-g-cell-1-1 eds-g-cell-md-8-12">
                    <ArticleCard
                        style={HERO_STYLE}
                        imageStyle={IMAGE_STYLE_FLUID}
                        trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                        {...primaryCard}
                    />
                </div>
                <div className="eds-g-cell eds-g-cell-1-1 eds-g-cell-md-4-12 eds-show-up-mn">
                    {_getRemainingArticleCards(
                        remainingCards,
                        trackGAEventOnPageUnload,
                        false,
                        'eds-g-cell eds-g-cell-6-12 eds-g-cell-md-1-1',
                    )}
                </div>
            </div>
            <div className="eds-show-down-sw">
                <div className="eds-g-cell eds-g-cell-1-1">
                    {_getRemainingArticleCards(
                        cards,
                        trackGAEventOnPageUnload,
                        true,
                    )}
                </div>
            </div>
        </div>
    );
};
